module.exports = __webpack_public_path__ + "img/YouTube.27f37b2e.svg";